export const FORM_ITEMS = [
  {
    id: 'amount',
    submitKey: 'loan_limit_number',
    type: 'input',
    submitType: 'input',
  },
  {
    id: 'term',
    submitKey: 'term_months',
    type: 'select',
    submitType: 'select',
  },
  {
    id: 'purpose',
    submitKey: 'loan_purpose',
    type: 'miltySelect',
    submitType: 'miltySelect',
  },
  {
    id: 'currency',
    submitKey: 'currency',
    type: 'select',
    submitType: 'select',
    defaultValue: 'uah',
  },
  {
    id: 'location_id',
    submitKey: 'location_id',
    type: 'miltySelect',
    submitType: 'select', // location_id=1,2,3
  },
  {
    id: 'vendor_id',
    submitKey: 'vendor_id',
    type: 'miltySelect',
    submitType: 'select', // vendor_id=1,2,3
  },
  {
    id: 'provision_form',
    submitKey: 'provision_form',
    type: 'select',
    submitType: 'select',
  },
  {
    id: 'support_program',
    submitKey: 'support_program',
    type: 'select',
    submitType: 'select',
  },
  {
    id: 'is_loan_security',
    submitKey: 'is_loan_security',
    type: 'select',
    submitType: 'select',
  },
  {
    id: 'loan_security',
    submitKey: 'loan_security',
    type: 'select',
    submitType: 'select',
  },
  {
    id: 'loan_recipient',
    submitKey: 'loan_recipient',
    type: 'miltySelect',
    submitType: 'miltySelect',
  },
  {
    id: 'business_size',
    submitKey: 'business_size',
    type: 'miltySelect',
    submitType: 'miltySelect',
  },
  {
    id: 'activity_scope',
    submitKey: 'activity_scope',
    type: 'miltySelect',
    submitType: 'miltySelect',
  },
  {
    id: 'registration_period',
    submitKey: 'minimal_business_registration_period',
    type: 'input',
    submitType: 'input',
  },
  {
    id: 'online_submission',
    submitKey: 'online_submission',
    type: 'select',
    submitType: 'select',
  },
  {
    id: 'is_prepayment',
    submitKey: 'is_prepayment',
    type: 'select',
    submitType: 'select',
  },
  {
    id: 'personal_assistance',
    submitKey: 'personal_assistance',
    type: 'select',
    submitType: 'select',
  },
  {
    id: 'online_cabinet',
    submitKey: 'online_cabinet',
    type: 'select',
    submitType: 'select',
  },
  {
    id: 'is_loan_surety',
    submitKey: 'is_loan_surety',
    type: 'select',
    submitType: 'select',
  },
];

export const DEFAULT_SORT = 'loanLimitNumberMax';
